module.exports = __webpack_public_path__ + "img/146.6.742d8410.png";